import { Routes, Route } from "react-router-dom"; // handling routing in the app.navigation between different pages with one URL client server routing
import "./App.css";
import Navigation from "./components/Navigation";
import Home from "./components/Home";
import AboutMe from "./components/AboutMe";
import Contact from "./components/Contact";
import AuroraBackground from "./components/ui/AuroraBackground";
import SimplePricingWithThreeTiers from "./components/Services";

function App() {
  return (
    <div className="app relative h-screen">
      <AuroraBackground showRadialGradient={true} />
      <Navigation />
      <div className="content-container z-10 relative">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutme" element={<AboutMe />} />
          <Route path="/services" element={<SimplePricingWithThreeTiers />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
